import { useMemo } from "react";
import { object, string } from "yup";


export type CheckMailCode = {
  email: string;
  code: string;
  password?: string;
};

const useValidationSchemaMailCode = (askForPassword?: boolean) => {
  return useMemo(() => {
    const requiredMessage = "form.error.notEmpty";

    // Schema représentant l'ensemble des champs du formulaire
    // inclu la validation de ces champs si nécessaire
    const validationSchema = object<CheckMailCode>().shape({
      email: string(),
      code: string().required(requiredMessage),
      password: askForPassword ? string().required(requiredMessage) : string(),
    });
    return validationSchema;
  }, []);
};

export default useValidationSchemaMailCode;
